import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.id}`}
      className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[16/9] overflow-hidden">
        <img
          src={article.image}
          alt={article.title}
          title={article.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-3 mb-2.5">
          <span className="text-xs text-foreground-400">{article.date}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
          <span className="text-xs text-foreground-400">{article.readTime}</span>
        </div>
        <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2 mb-2">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed mb-3">
          {article.excerpt}
        </p>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-1.5">
            <div className="w-5 h-5 rounded-full bg-secondary-200 flex items-center justify-center">
              <i className="ri-user-line text-secondary-600 text-xs"></i>
            </div>
            <span className="text-xs text-foreground-500">{article.author}</span>
          </div>
          <div className="flex flex-wrap gap-1.5">
            {article.tags.slice(0, 2).map((tag) => (
              <span key={tag} className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-md">
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </Link>
  );
}